import EventEmitter from "events";
import { matchFilters, hasValidSignature } from "./util/nostr.mjs";
export class Subscription extends EventEmitter {
    constructor(opts) {
        super();
        this.opts = opts;
        this.dead = new Set();
        this.seen = new Set();
        this.eose = new Set();
        this.closeHandlers = new Map();
        this.opened = Date.now();
        this.hasSeen = (event, url) => {
            if (this.opts.hasSeen) {
                return this.opts.hasSeen(event, url);
            }
            if (this.seen.has(event.id)) {
                return true;
            }
            this.seen.add(event.id);
            return false;
        };
        this.hasValidSignature = (event, url) => {
            if (this.opts.shouldValidate && !this.opts.shouldValidate(event, url)) {
                return true;
            }
            return hasValidSignature(event);
        };
        this.onEvent = (url, event) => {
            // If we've seen this event, don't re-validate
            // Otherwise, check the signature and filters
            if (this.hasSeen(event, url)) {
                this.emit("duplicate", event, url);
            }
            else {
                if (!this.hasValidSignature(event, url)) {
                    this.emit("invalid-signature", event, url);
                }
                else if (!matchFilters(this.opts.filters, event)) {
                    this.emit("failed-filter", event, url);
                }
                else {
                    this.emit("event", event, url);
                }
            }
        };
        this.onEose = (url) => {
            const { executor, closeOnEose } = this.opts;
            this.emit("eose", url);
            this.eose.add(url);
            if (closeOnEose && this.eose.size === executor.target.connections.length) {
                this.close();
            }
        };
        this.close = () => {
            if (!this.closed) {
                const { target } = this.opts.executor;
                this.closed = Date.now();
                this.unsubscribe();
                this.emit("close");
                this.removeAllListeners();
                target.connections.forEach(con => con.off("close", this.closeHandlers.get(con.url)));
                target.cleanup();
            }
        };
        const { executor, timeout, filters } = this.opts;
        // If we have a timeout, close the subscription automatically
        if (timeout) {
            setTimeout(this.close, timeout);
        }
        // If one of our connections gets closed make sure to kill our sub
        executor.target.connections.forEach(con => {
            const handler = () => {
                this.dead.add(con.url);
                if (this.dead.size === executor.target.connections.length) {
                    this.close();
                }
            };
            this.closeHandlers.set(con.url, handler);
            con.on("close", handler);
        });
        // Start our subscription
        const sub = executor.subscribe(filters, {
            onEvent: this.onEvent,
            onEose: this.onEose,
        });
        this.unsubscribe = sub.unsubscribe;
    }
}
//# sourceMappingURL=Subscription.mjs.map